var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { Amount } from 'ui';
import { toPercentage } from 'utils/parse';
import { getSizedImage } from 'utils/images';
import useIsMobile from '../../hooks/useIsMobile.js';
import { getAccessibleColor, getRGBColor, getShadeColor } from 'utils/layout';
import styles from './PromotionPopUp.module.css';
import urlHelper from 'url';
export var PopupBehaviourType;
(function (PopupBehaviourType) {
    PopupBehaviourType["EXIT_POPUP"] = "EXIT_POPUP";
    PopupBehaviourType["INACTIVITY"] = "INACTIVITY";
})(PopupBehaviourType || (PopupBehaviourType = {}));
export var PopupPosition;
(function (PopupPosition) {
    PopupPosition["MID"] = "MID";
    PopupPosition["LEFT"] = "LEFT";
    PopupPosition["RIGHT"] = "RIGHT";
})(PopupPosition || (PopupPosition = {}));
export const PopupPositionOptions = {
    MID: 'MID',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};
export const PromotionPopup = React.forwardRef((props, ref) => {
    var _a;
    const { extraParams, promotion, photo, design, content, onCancel, currency, onApply, onButtonClick, useTailwindPrefix, saveCSSVarColorsWithotPrefix, transformFontFamilyName, } = props;
    const isMobile = useIsMobile();
    const photoPosition = (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND' ? null : (design === null || design === void 0 ? void 0 : design.layout) || (photo === null || photo === void 0 ? void 0 : photo.position);
    const previewLayout = classNames(Object.assign({ 'rounded-[inherit] overflow-hidden relative bg-white': !useTailwindPrefix, 'tw-rounded-[inherit] tw-overflow-hidden tw-relative tw-bg-white': useTailwindPrefix }, (!useTailwindPrefix
        ? Object.assign({ 'flex items-center min-h-[350px] md:min-h-[600px]': (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND', 'grid grid-cols-2': photo &&
                (photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
                !isMobile }, (!isMobile
            ? {
                'text-left': (design === null || design === void 0 ? void 0 : design.desktopAlignment) === 'left' ||
                    (!(design === null || design === void 0 ? void 0 : design.desktopAlignment) && photo && photoPosition === PopupPositionOptions.LEFT),
                'text-center': (design === null || design === void 0 ? void 0 : design.desktopAlignment) === 'center' ||
                    (!(design === null || design === void 0 ? void 0 : design.desktopAlignment) &&
                        photo &&
                        (photoPosition === PopupPositionOptions.MID || (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND')),
                'text-right': (design === null || design === void 0 ? void 0 : design.desktopAlignment) === 'right' ||
                    (!(design === null || design === void 0 ? void 0 : design.desktopAlignment) && photo && photoPosition === PopupPositionOptions.RIGHT),
            }
            : {
                'text-left': (design === null || design === void 0 ? void 0 : design.mobileAlignment) === 'left' ||
                    (!(design === null || design === void 0 ? void 0 : design.mobileAlignment) && photo && photoPosition === PopupPositionOptions.LEFT),
                'text-center': (design === null || design === void 0 ? void 0 : design.mobileAlignment) === 'center' ||
                    (!(design === null || design === void 0 ? void 0 : design.mobileAlignment) &&
                        photo &&
                        (photoPosition === PopupPositionOptions.MID || (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND')),
                'text-right': (design === null || design === void 0 ? void 0 : design.mobileAlignment) === 'right' ||
                    (!(design === null || design === void 0 ? void 0 : design.mobileAlignment) && photo && photoPosition === PopupPositionOptions.RIGHT),
            })) : Object.assign({ 'tw-flex tw-items-center tw-min-h-[350px] md:tw-min-h-[600px]': (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND', 'tw-grid tw-grid-cols-2': photo &&
            (photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
            !isMobile }, (!isMobile
        ? {
            'tw-text-left': (design === null || design === void 0 ? void 0 : design.desktopAlignment) === 'left' ||
                (!(design === null || design === void 0 ? void 0 : design.desktopAlignment) && photo && photoPosition === PopupPositionOptions.LEFT),
            'tw-text-center': (design === null || design === void 0 ? void 0 : design.desktopAlignment) === 'center' ||
                (!(design === null || design === void 0 ? void 0 : design.desktopAlignment) && photo && photoPosition === PopupPositionOptions.MID),
            'tw-text-right': (design === null || design === void 0 ? void 0 : design.desktopAlignment) === 'right' ||
                (!(design === null || design === void 0 ? void 0 : design.desktopAlignment) && photo && photoPosition === PopupPositionOptions.RIGHT),
        }
        : {
            'tw-text-left': (design === null || design === void 0 ? void 0 : design.mobileAlignment) === 'left' ||
                (!(design === null || design === void 0 ? void 0 : design.mobileAlignment) && photo && photoPosition === PopupPositionOptions.LEFT),
            'tw-text-center': (design === null || design === void 0 ? void 0 : design.mobileAlignment) === 'center' ||
                (!(design === null || design === void 0 ? void 0 : design.mobileAlignment) && photo && photoPosition === PopupPositionOptions.MID),
            'tw-text-right': (design === null || design === void 0 ? void 0 : design.mobileAlignment) === 'right' ||
                (!(design === null || design === void 0 ? void 0 : design.mobileAlignment) && photo && photoPosition === PopupPositionOptions.RIGHT),
        })))));
    const styleImage = classNames(Object.assign({ 'bg-cover bg-center': !useTailwindPrefix, 'tw-bg-cover tw-bg-center': useTailwindPrefix }, (!useTailwindPrefix
        ? {
            'inset-0 absolute': photo && (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND',
            'col-start-1 row-start-1': photo && photoPosition === PopupPositionOptions.LEFT && !isMobile,
            'col-start-2 row-start-1': photo && photoPosition === PopupPositionOptions.RIGHT && !isMobile,
            'md:min-h-[250px] min-h-[195px]': (photo && photoPosition === PopupPositionOptions.MID) ||
                ((photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
                    isMobile),
        }
        : {
            'tw-inset-0 tw-absolute': photo && (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND',
            'tw-col-start-1 tw-row-start-1': photo && photoPosition === PopupPositionOptions.LEFT && !isMobile,
            'tw-col-start-2 tw-row-start-1': photo && photoPosition === PopupPositionOptions.RIGHT && !isMobile,
            'tw-md:min-h-[250px] tw-min-h-[195px]': (photo && photoPosition === PopupPositionOptions.MID) ||
                ((photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
                    isMobile),
        })));
    const styleText = classNames(Object.assign({ [styles.textShadow]: (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND' }, (!useTailwindPrefix
        ? {
            'flex-1 px-4 z-[1]': (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND',
            'flex flex-col justify-between px-4': photo &&
                (photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
                !isMobile,
            'col-start-1': photo && photoPosition === PopupPositionOptions.RIGHT && !isMobile,
            'px-4': (photo && photoPosition === PopupPositionOptions.MID) || isMobile,
        }
        : {
            'tw-flex-1 tw-px-4 tw-z-[1]': (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND',
            'tw-flex tw-flex-col tw-justify-between tw-px-4': photo &&
                (photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
                !isMobile,
            'tw-col-start-1': photo && photoPosition === PopupPositionOptions.RIGHT && !isMobile,
            'tw-px-4': (photo && photoPosition === PopupPositionOptions.MID) || isMobile,
        })));
    const intl = useIntl();
    const getDiscount = (promotion) => {
        let result = null;
        if (promotion.rollingEBBSettings && promotion.rollingEBBSettings.length > 0) {
            result = promotion.rollingEBBSettings.map((rebb) => (_jsx("div", { children: intl.formatMessage({ id: 'common.rooms.promotion.ebb' }, { days: rebb.days, discountPercentage: toPercentage(rebb.discountPercentage) }) }, `rebb-${rebb.id}`)));
        }
        else if (promotion.discountPercentage && promotion.discountPercentage > 0) {
            result = (_jsxs("span", { children: [toPercentage(promotion.discountPercentage), "% ", intl.formatMessage({ id: 'common.rooms.promotion.off' })] }));
        }
        else if (promotion.discount && promotion.discount > 0) {
            result = (_jsxs("span", { children: [_jsx(Amount, { amount: promotion.discount, currency: currency }), ' ', intl.formatMessage({ id: 'common.rooms.promotion.byRoom.byNight.discount' })] }));
        }
        if (result) {
            return _jsx("li", { children: result });
        }
        return result;
    };
    const drawPhotoComponent = () => {
        if (!photo) {
            return null;
        }
        const isVideo = photo.path.endsWith('.mp4') || photo.path.endsWith('.webm') || photo.path.endsWith('.mpeg');
        if (isVideo) {
            return (_jsx("div", Object.assign({ className: styleImage }, { children: _jsx("video", Object.assign({ muted: true, playsInline: true, autoPlay: true, loop: true, className: classNames({
                        'object-cover h-full w-full': !useTailwindPrefix,
                        'tw-object-cover tw-h-full tw-w-full': useTailwindPrefix,
                    }) }, { children: drawVideoSource(photo &&
                        (photoPosition === PopupPositionOptions.LEFT || photoPosition === PopupPositionOptions.RIGHT) &&
                        !isMobile
                        ? {
                            sizes: 'w_299,h_400,c_crop',
                        }
                        : (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND'
                            ? { sizes: isMobile ? 'w_350,h_350,c_crop' : 'w_600,h_600,c_crop' }
                            : { sizes: 'w_600,h_337,c_crop' }, photo) }), photo.path) })));
        }
        else {
            return (_jsx("div", Object.assign({ className: styleImage }, { children: _jsx("img", { src: getPhotoPreviewURL(), srcSet: `${getPhotoPreviewURL('2.0')} 2x`, alt: (content === null || content === void 0 ? void 0 : content.title) || 'Promotion', className: classNames({
                        'w-full h-full object-cover': !useTailwindPrefix,
                        'tw-w-full tw-h-full tw-object-cover': useTailwindPrefix,
                    }) }) })));
        }
    };
    const getPhotoPreviewURL = (dpr) => {
        if (!photo) {
            return '';
        }
        let url = photo.basePath + photo.path;
        const options = (photoPosition === 'LEFT' || photoPosition === 'RIGHT') && !isMobile
            ? { w: 299, h: 400, fit: 'crop', dpr }
            : (design === null || design === void 0 ? void 0 : design.layout) === 'BACKGROUND'
                ? isMobile
                    ? { w: 350, h: 350, fit: 'crop', dpr }
                    : { w: 600, h: 600, fit: 'crop', dpr }
                : { w: 600, h: 337, fit: 'crop', dpr };
        let imageUrl = getSizedImage(url, options);
        return imageUrl;
    };
    function drawVideoSource(item, photo) {
        if (!photo)
            return null;
        const urlObject = urlHelper.parse(photo.basePath + photo.path);
        if (!urlObject.pathname)
            return null;
        const pathParts = urlObject.pathname.split('/');
        const bucket = pathParts.splice(1, 1);
        const path = pathParts.join('/').replace(/\.(mp4|webm|mpeg)$/, '');
        return (_jsxs(_Fragment, { children: [_jsx("source", Object.assign({}, (item.media ? { media: item.media } : {}), { src: `https://${urlObject.host}/${bucket}/video/upload/c_limit,f_mp4,q_auto,vc_h265${item.sizes ? `,${item.sizes}` : ''}${path}.mp4`, type: "video/mp4; codecs=hvc1" })), _jsx("source", Object.assign({}, (item.media ? { media: item.media } : {}), { src: `https://${urlObject.host}/${bucket}/video/upload/c_limit,f_webm,q_auto,vc_vp9${item.sizes ? `,${item.sizes}` : ''}${path}.webm`, type: "video/webm; codecs=vp9" })), _jsx("source", Object.assign({}, (item.media ? { media: item.media } : {}), { src: `https://${urlObject.host}/${bucket}/video/upload/c_limit,q_auto${item.sizes ? `,${item.sizes}` : ''}${path}.mp4`, type: "video/mp4" }))] }));
    }
    function mod_getRGBColor(hex, name) {
        if (saveCSSVarColorsWithotPrefix) {
            return getRGBColor(hex, name, '');
        }
        return getRGBColor(hex, name);
    }
    function getStyleOptions() {
        const values = [];
        // const bg = design?.textStyle.find((s) => s.type === 'BACKGROUND')
        // values.push(mod_getRGBColor(bg?.backgroundColor || '#ffffff', 'alerts-popup-background'))
        const text = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BODY');
        values.push(mod_getRGBColor((text === null || text === void 0 ? void 0 : text.color) || '#565a5c', 'alerts-popup-a11y'));
        if (text === null || text === void 0 ? void 0 : text.fontFamily) {
            values.push(`--ppu-body-fontFamily: ${(transformFontFamilyName === null || transformFontFamilyName === void 0 ? void 0 : transformFontFamilyName(text.fontFamily)) || text.fontFamily};`);
        }
        if (text === null || text === void 0 ? void 0 : text.fontSize) {
            values.push('--ppu-body-fontSize: ' + text.fontSize + ';');
        }
        const button = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BUTTON');
        values.push(mod_getRGBColor((button === null || button === void 0 ? void 0 : button.color) || '#333333', 'alerts-popup-button-a11y'));
        values.push(mod_getRGBColor((button === null || button === void 0 ? void 0 : button.backgroundColor) || '#ffffff', 'alerts-popup-button-background'));
        values.push(mod_getRGBColor(getShadeColor((button === null || button === void 0 ? void 0 : button.backgroundColor) || '#ffffff', getAccessibleColor((button === null || button === void 0 ? void 0 : button.backgroundColor) || '#ffffff') === '#000000' ? -0.1 : 0.1), 'alerts-popup-button-background-hover'));
        values.push(mod_getRGBColor((button === null || button === void 0 ? void 0 : button.borderColor) || '#333333', 'alerts-popup-button-border'));
        const header = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'HEADER');
        values.push(mod_getRGBColor((header === null || header === void 0 ? void 0 : header.color) || '#333333', 'alerts-popup-header-text'));
        if (header === null || header === void 0 ? void 0 : header.fontFamily) {
            values.push('--ppu-header-fontFamily: ' + ((transformFontFamilyName === null || transformFontFamilyName === void 0 ? void 0 : transformFontFamilyName(header.fontFamily)) || header.fontFamily) + ';');
        }
        if (header === null || header === void 0 ? void 0 : header.fontSize) {
            values.push('--ppu-header-fontSize: ' + header.fontSize + ';');
        }
        return values;
    }
    function getAction() {
        if (!content) {
            return null;
        }
        if (content.buttonUrl && content.buttonUrl !== '') {
            const url = (() => {
                const qs = new URLSearchParams(extraParams !== null && extraParams !== void 0 ? extraParams : {}).toString();
                if (!qs)
                    return content.buttonUrl;
                return `${content.buttonUrl}${content.buttonUrl.includes('?') ? '&' : '?'}${qs}`;
            })();
            if (onButtonClick) {
                return {
                    onClick: () => __awaiter(this, void 0, void 0, function* () {
                        yield onButtonClick();
                        window.open(url, '_blank', 'noopener,noreferrer');
                    }),
                    defaultLabelId: 'common.popup.ok',
                };
            }
            return { href: url, defaultLabelId: 'common.popup.ok' };
        }
        else if (promotion && promotion.code) {
            return {
                onClick: () => __awaiter(this, void 0, void 0, function* () {
                    yield (onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick());
                    onApply(promotion, extraParams !== null && extraParams !== void 0 ? extraParams : {});
                }),
                defaultLabelId: 'common.popup.applyCode',
            };
        }
        return null;
    }
    function drawButton() {
        const action = getAction();
        if (!content || !action) {
            return null;
        }
        const buttonClasses = classNames(styles.button, {
            'inline-block mt-2 px-3 py-1.5 bg-alerts-popup-button-background text-alerts-popup-button-a11y border border-alerts-popup-button-border hover:bg-alerts-popup-button-background-hover transition': !useTailwindPrefix,
            'tw-inline-block tw-mt-2 tw-px-3 tw-py-1.5 tw-bg-alerts-popup-button-background tw-text-alerts-popup-button-a11y tw-border tw-border-alerts-popup-button-border hover:tw-bg-alerts-popup-button-background-hover tw-transition': useTailwindPrefix,
        });
        const label = content.buttonText || intl.formatMessage({ id: action.defaultLabelId });
        if (action.href) {
            return (_jsx("a", Object.assign({ href: action.href, target: "_blank", rel: "noopener noreferrer", className: buttonClasses }, { children: label })));
        }
        return (_jsx("button", Object.assign({ type: "button", className: buttonClasses, onClick: action.onClick }, { children: label })));
    }
    function drawPromotion() {
        if (!promotion || !promotion.code) {
            return null;
        }
        return (_jsxs("div", Object.assign({ className: classNames({
                'bg-black/5 py-6 px-4 text-muted -mx-4 mb-6': !useTailwindPrefix,
                'tw-bg-black/5 tw-py-6 tw-px-4 tw-text-muted -tw-mx-4 tw-mb-6': useTailwindPrefix,
            }) }, { children: [_jsxs("ul", Object.assign({ className: classNames({
                        'mb-3 leading-normal font-bold': !useTailwindPrefix,
                        'tw-mb-3 tw-leading-normal tw-font-bold': useTailwindPrefix,
                    }) }, { children: [getDiscount(promotion), promotion.kidsFree && (_jsx("li", { children: intl.formatMessage({ id: 'common.rooms.promotion.minors.free' }, { quantity: promotion.kidsFreeMax || 0 }) })), promotion.isTwoForOne && _jsx("li", { children: "2 x 1" }), promotion.isNightFree && !promotion.secondNightFree && (_jsx("li", { children: intl.formatMessage({ id: 'common.rooms.promotion.night.free.simple' }, { quantity: promotion.nightFree }) })), promotion.isNightFree && promotion.secondNightFree && (_jsxs(_Fragment, { children: [_jsx("li", { children: intl.formatMessage({ id: 'common.rooms.promotion.night.free' }, { quantity: 1, days: promotion.nightFree }) }), _jsx("li", { children: intl.formatMessage({ id: 'common.rooms.promotion.night.free' }, { quantity: 2, days: promotion.secondNightFree }) })] })), promotion.addedValueTitle && promotion.addedValueDescription && (_jsx("li", { children: promotion.addedValueDescription }))] })), _jsx("div", Object.assign({ className: classNames({ 'text-[0.875em]': !useTailwindPrefix, 'tw-text-[0.875em]': useTailwindPrefix }) }, { children: intl.formatMessage({ id: 'common.popup.usePromoCode' }, { code: promotion.code }) }))] })));
    }
    function drawCloseButton() {
        if (!onCancel) {
            return null;
        }
        return (_jsx("button", Object.assign({ className: classNames({
                'text-white/70 hover:text-white bg-black/50 hover:bg-black/30 absolute top-1 right-1 z-10 w-8 h-8 rounded-full flex items-center justify-center transition cursor-pointer': !useTailwindPrefix,
                'tw-text-white/70 hover:tw-text-white tw-bg-black/50 hover:tw-bg-black/30 tw-absolute tw-top-1 tw-right-1 tw-z-10 tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition tw-cursor-pointer': useTailwindPrefix,
            }), onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                onCancel(e);
            } }, { children: _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", className: classNames({ 'h-6 w-6': !useTailwindPrefix, 'tw-h-6 tw-w-6': useTailwindPrefix }), fill: "currentColor" }, { children: _jsx("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" }) })) })));
    }
    const containerAction = (content === null || content === void 0 ? void 0 : content.openLinkOnClick) ? getAction() : null;
    const isAnchor = !!(containerAction === null || containerAction === void 0 ? void 0 : containerAction.href);
    const containerProps = containerAction
        ? containerAction.href
            ? { href: containerAction.href, target: '_blank', rel: 'noopener noreferrer' }
            : { onClick: containerAction.onClick, style: { cursor: 'pointer' } }
        : {};
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `:root {
               ${(_a = getStyleOptions()) === null || _a === void 0 ? void 0 : _a.join(' ')}
            }` }), React.createElement(isAnchor ? 'a' : 'div', Object.assign({ className: previewLayout, ref }, containerProps), _jsxs(_Fragment, { children: [drawPhotoComponent(), _jsxs("div", Object.assign({ className: styleText }, { children: [_jsx("div", Object.assign({ className: classNames({ 'py-[18px]': !useTailwindPrefix, 'tw-py-[18px]': useTailwindPrefix }) }, { children: (content === null || content === void 0 ? void 0 : content.title) && (_jsx("h2", Object.assign({ className: classNames(styles.header, {
                                        'font-bold mb-1 text-alerts-popup-header-text': !useTailwindPrefix,
                                        'tw-font-bold tw-mb-1 tw-text-alerts-popup-header-text': useTailwindPrefix,
                                    }) }, { children: content.title }))) })), _jsxs("div", Object.assign({ className: classNames(styles.body, {
                                    'text-alerts-popup-a11y': !useTailwindPrefix,
                                    'tw-text-alerts-popup-a11y': useTailwindPrefix,
                                }) }, { children: [(content === null || content === void 0 ? void 0 : content.description) && (_jsx("div", { className: classNames(styles.content, {
                                            'mb-6': !useTailwindPrefix,
                                            'tw-mb-6': useTailwindPrefix,
                                        }), dangerouslySetInnerHTML: { __html: content.description } })), content && !content.openLinkOnClick && drawPromotion()] })), content && !content.openLinkOnClick && (_jsx("div", Object.assign({ className: classNames({ 'pb-4': !useTailwindPrefix, 'tw-pb-4': useTailwindPrefix }) }, { children: drawButton() })))] })), drawCloseButton()] }))] }));
});
